import state from './state'

export default {
    getCountries:   () => state.countries || [],
    getStates:      () => state.states || [],
    getCities:      () => state.cities || [],
}